'use strict';

angular.module('casist.core')
  .factory('Obdobie', ['Restangular', 'BaseModel', 'BaseCollectionModel', function (Restangular, BaseModel, BaseCollectionModel) {
    Restangular.extendModel('obdobie', function(model) {
      angular.extend(model, BaseModel)
      return angular.extend(model, {
        validate: function() {
          return BaseModel.validate();
        }
      });
    });
    return BaseCollectionModel.object('settings/obdobie');
  }]);
